import Collection from './Collection'
import SeatGridService from '../service/seat-grid-service'

export default class SeatGrid extends Collection {

    constructor(data) {
        super('grid');
        this.grid = data || [];
    }


    mapTicketsToGrid(tickets) {
        for (var i = 0; i < this.grid.length; i++) {
            var row = this.grid[i];

            for (var j = 0; j < row.Seats.length; j++) {
                var seatGroup = row.Seats[j];
                seatGroup.selected = false;
                seatGroup.ticket = undefined;
                for (var k = 0; k < seatGroup.seats.length; k++) {
                    var seat = seatGroup.seats[k];
                    if (seat && seat.Id) {
                        var seatName = row.PhysicalName + seat.Id;
                        var ticket = tickets.find((ticket)=>ticket.SeatData === seatName);
                        if (ticket) {
                            seatGroup.available = true;
                            // seatGroup.type = 1;
                            ticket.Position = seat.Position;
                            seat.ticket = ticket;
                            seatGroup.ticket = ticket;
                            seatGroup.selected = true;
                            ticket.SeatRowId = row.PhysicalName;
                        } else {
                            seat.ticket = undefined;
                            seatGroup.ticket = undefined;
                            seatGroup.selected = false;
                        }

                    }

                }

            }

        }
    }


}




// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/SeatGrid.js